/**
 * Casca do MODO JANELA (`?janela=1`): mesma árvore de rotas de `/app`, só que
 * sem o menu principal — o processo aberto numa janela dedicada usa a largura
 * inteira, e o advogado trabalha em vários ao mesmo tempo.
 *
 * Mantém o que o conteúdo depende (gate de assinatura, FAB, container rolável
 * com as MESMAS medidas do `SidebarLayout`, das quais as telas derivam altura).
 * Por isso atende os mesmos pedidos de cromo do `SidebarLayout` que mexem nessas
 * medidas — colar e tirar o respiro (`lib/cromoApp`): inerte, ele deixava os autos
 * 48px mais altos que a janela, com rolagem dupla. Menu não há, então não há o que
 * ocultar nem abrir.
 */
import { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { CromoAppContext, type CromoApp } from '@/lib/cromoApp';
import { cn } from '@/lib/utils';

import { AtuacaoFilete, SincronizarAtuacao } from './delegacao/AtuacaoShell';
import { SubscriptionGate } from './SubscriptionGate';
import { FabProvider, FabRenderer } from './ui/Fab';

export default function SlimLayout() {
  const [colado, setColado] = useState(false);
  const [semRespiro, setSemRespiro] = useState(false);
  const cromo = useMemo<CromoApp>(
    () => ({ pedirOcultacao: () => {}, pedirColagem: setColado, pedirSemRespiro: setSemRespiro }),
    [],
  );

  return (
    <CromoAppContext.Provider value={cromo}>
      {/* Sem barra do app: no celular o topo é só o respiro de 1rem (ver `--topo-app` no SidebarLayout). */}
      <div className="flex h-[calc(100dvh-var(--env-banner-h,0px))] overflow-hidden bg-[var(--color-bg-default)] [--topo-app:1rem]">
        <FabProvider>
          <main
            id="main-content"
            tabIndex={-1}
            className={cn(
              'min-w-0 flex-1 overflow-y-auto overscroll-contain bg-[var(--color-bg-dark)] p-4 outline-none sm:p-6',
              colado && 'sm:px-4 sm:py-3',
              semRespiro && 'sm:p-0',
            )}
          >
            <SincronizarAtuacao />
            <AtuacaoFilete />
            <SubscriptionGate>
              <Outlet />
            </SubscriptionGate>
          </main>
          <FabRenderer />
        </FabProvider>
      </div>
    </CromoAppContext.Provider>
  );
}
